import React, { useState } from 'react';

import content from 'assets/content/product.content.json';

import info from 'assets/images/general/info.png';
import SamsungDaBasket from 'assets/images/general/samsung-da-basket.svg';

import './AutomaticOwnership.scss';
import AutomaticOwnershipModal from './AutomaticOwnershipModal/AutomaticOwnershipModal';

export default function AutomaticOwnership() {
    const data = {
        id: 1,
        icon: SamsungDaBasket,
        title: content?.CONTENT.AUTOMATIC_OWNERSHIP_TITLE,
        desc: content?.CONTENT.AUTOMATIC_OWNERSHIP_DESC
    };

    const [isOpenForAutomaticOwnershipModal, setIsOpenForAutomaticOwnershipModal] = useState(false);

    const onToggle = () => {
        setIsOpenForAutomaticOwnershipModal(!isOpenForAutomaticOwnershipModal);
    };

    return (
        <>
            <div className='automaticOwnership width-100'>
                <div key={data.id} className='automaticOwnership__tile' onClick={() => onToggle(data.icon)}>
                    <img className='icon' src={data.icon} alt={data.title} />
                    <div className='w-100 content'>
                        <p className='content__title d-flex justify-content-between'>
                            <span>{data.title}</span>
                            <img className='icon' src={info} alt='info'/>
                        </p>
                        <p className='content__desc'>{data.desc}</p>
                    </div>
                </div>
            </div>
            <AutomaticOwnershipModal isOpen={isOpenForAutomaticOwnershipModal} onToggle={() => onToggle()}/>
        </>
    );
}
